'use client'

import { Cell, Container, Radio, Text } from '@vinted/web-ui'
import { useIntl } from 'react-intl'

import { formatCurrencyAmount } from '@marketplace-web/domain/currency-data'
import { BumpOptionModel } from '@marketplace-web/vas/vas-data'

import BestValueBadge from '../../BestValueBadge'

type Props = {
  isSelected: boolean
  bumpOption: BumpOptionModel
  onSelect: () => void
  isBestValue?: boolean
  isLoading: boolean
}

const BumpOptionListItem = ({ onSelect, isSelected, bumpOption, isLoading }: Props) => {
  const { locale } = useIntl()
  const { id, description, isBestValue, countries } = bumpOption

  function handleSelect() {
    if (isSelected) return

    onSelect()
  }

  function renderTitle() {
    return (
      <>
        {isBestValue && <BestValueBadge />}
        <Text as="span" text={description} />
      </>
    )
  }

  function renderBody() {
    if (!countries?.length) return null

    return <Text as="span" type={Text.Type.Caption} theme="muted" text={countries} />
  }

  function renderPriceAriaLabel() {
    if (isLoading) return ''

    return formatCurrencyAmount(bumpOption.payable, locale)
  }

  function renderSuffix() {
    return (
      <Container styling={Container.Styling.Narrow}>
        <Radio
          checked={isSelected}
          name="bump-option"
          value={id}
          onChange={() => undefined}
          tabIndex={isSelected ? 0 : -1}
          aria={{
            'aria-label': `${description} ${renderPriceAriaLabel()}`,
          }}
        />
      </Container>
    )
  }

  return (
    <Cell
      clickable
      title={renderTitle()}
      body={renderBody()}
      suffix={renderSuffix()}
      styling={Cell.Styling.Narrow}
      onClick={handleSelect}
      role="presentation"
      tabIndex={-1}
    />
  )
}

export default BumpOptionListItem
